module.exports = __webpack_public_path__ + "static/media/stock-7.3cae6a0e.jpg";